import React, { useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';
import Product from '@system/config/product';
import Constants from 'src/helper/Constants';
import { useHomePageContentStore } from "src/hooks/HomePageContent";
import AllContentTab from "./ContentTabs/AllContentTab";
import ArticlesTab from "./ContentTabs/ArticlesTab";
import VideoTab from "./ContentTabs/VideoTab";
import SiteTab from "./ContentTabs/SiteTab";
import EventTab from "./ContentTabs/EventTab";
import Cookies from "js-cookie";

const HomePageContentTabsListing = () => {
    const { homePageAllTabs, pathNameAmericasCookie } = Constants
    const homeContentTabType = System.getParams().__c_HomePageContentTabList;
    const [selectedTab, setSelectedTab] = useReduxState(homePageAllTabs.ALLCONTENT.abbr, 'searchContentTabParams')
    const [searchParams] = useSearchParams();
    const [{ allTabsCount }, { }] = useHomePageContentStore();
    const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedFilterList');
    const [filterFacets, setFilterFacets] = useReduxState([], 'setFilterFacets');

    let defaultTabList = {
        ALLCONTENT: {
            name: homePageAllTabs.ALLCONTENT.tabHeader,
            param_value: homePageAllTabs.ALLCONTENT.abbr,
            count: 0
        },
        ARTICLE: {
            name: homePageAllTabs.ARTICLE.tabHeader,
            param_value: homePageAllTabs.ARTICLE.abbr,
            count: 0
        },

        EVENT: {
            name: homePageAllTabs.EVENT.tabHeader,
            param_value: homePageAllTabs.EVENT.abbr,
            count: 0
        },
        SITE: {
            name: homePageAllTabs.SITE.tabHeader,
            param_value: homePageAllTabs.SITE.abbr,
            count: 0
        },
        VIDEO: {
            name: homePageAllTabs.VIDEO.tabHeader,
            param_value: homePageAllTabs.VIDEO.abbr,
            count: 0
        }
    };

    const [homeContentTabList, setHomeContentTabList] = useState(defaultTabList)

    useEffect(() => {
        let temData = { ...homeContentTabList }
        temData.ALLCONTENT.count = allTabsCount?.allContentCount || 0
        temData.ARTICLE.count = allTabsCount?.articleCount || 0
        temData.EVENT.count = allTabsCount?.eventCount || 0
        temData.SITE.count = allTabsCount?.siteCount || 0
        temData.VIDEO.count = allTabsCount?.videoCount || 0
        setHomeContentTabList(temData)
    }, [allTabsCount])

    const getActiveClass = (singleElement) => {
        if (selectedTab === singleElement.param_value) {
            return "active";
        }
        return "";
    };


    const switchTab = async (tab) => {
        setSelectedTab(tab)
        setSelectedFilterList([])
        setFilterFacets([])
        const newUrl = `${Product.getProductListingPageRouteURL({ __c_HomeTabList: homePageAllTabs.CONTENT.abbr })}&__c_HomePageContentTabList=${tab}&search=${searchParams.get('search')}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
        Cookies.set(pathNameAmericasCookie, window.location.href);
    };


    useEffect(() => {
        async function fetchHere() {
            setSelectedTab(homeContentTabType ? homeContentTabType : homePageAllTabs.ALLCONTENT.abbr);
        }
        fetchHere();
    }, [homeContentTabType]);

    return (
        <>
            <div className="all-content-tabs">
                <ul className="nav nav-tabs">
                    {Object.entries(homeContentTabList).map((v) => (

                        <React.Fragment key={v[1].name}>

                            <li className={v[1].count === 0 ? 'bs5 nav-item disabled' : 'bs5 nav-item ' + getActiveClass(v[1])} key={v[1].name}>
                                <a className={'count hidden-xs hidden-sm'}
                                    href={void (0)}
                                    onClick={async (e) => {
                                        v[1].count > 0 ?
                                            await switchTab(v[1].param_value) : e.preventDefault()
                                    }}
                                >
                                    {v[1].name}
                                    <span className="count hidden-xs hidden-sm"> ({v[1].count})</span>
                                    <span className="count-bubble hidden-md hidden-lg"> {v[1].count}</span>
                                </a>
                            </li>
                        </React.Fragment>
                    ))}
                </ul>
            </div>
            <div className="search-page-tab mobile-tab">

                <div id={selectedTab} className="active" >
                    {selectedTab === homePageAllTabs.ALLCONTENT.abbr && <AllContentTab handleChangeTab={switchTab} />}
                    {selectedTab === homePageAllTabs.ARTICLE.abbr && <ArticlesTab />}
                    {selectedTab === homePageAllTabs.EVENT.abbr && <EventTab />}
                    {selectedTab === homePageAllTabs.SITE.abbr && <SiteTab />}
                    {selectedTab === homePageAllTabs.VIDEO.abbr && <VideoTab />}
                </div>
            </div>
        </>
    )
}

export default HomePageContentTabsListing